import type { PerformanceDeltaResponseModel } from "@/features/performanceDeltas/api/usePerformanceDeltas";
import type { PerformanceDeltaSort } from "@/features/performanceDeltas/PerformanceDeltaSort";
import type { PerformanceDeltaStep } from "@/features/performanceDeltas/PerformanceDeltaStep";
import { useHTTP } from "@/lib/http";
import type { PaginatedResponseModel } from "@/lib/http/PaginatedResponseModel";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const useValuedCollectionsPerformanceDeltas = (step: PerformanceDeltaStep, minimumPrice: number, sort: PerformanceDeltaSort) => {
	const http = useHTTP("Required");
	return useHTTPQueryWithCursor({
		queryKey: ["dashboardPerformanceDeltas", step, minimumPrice, sort],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<PerformanceDeltaResponseModel>>({
				method: "GET",
				url: `/performance-deltas/search/collections?q=&step=${step}&minimumPrice=${minimumPrice}&sort=${sort}&cursor=${pageParam}`
			});
		}
	});
};
